export function isFileImage(fileName: string) {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'bmp'];

  const extension = fileName.includes('.') ? fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase() : fileName;
  return imageExtensions.includes(extension);
}